// extracted by mini-css-extract-plugin
export default {"breadCrumbs":"Crumbs_breadCrumbs__BhyEv","crumbsLink":"Crumbs_crumbsLink__ORPNl","iconBreadcrumbs":"Crumbs_iconBreadcrumbs__lRKxZ"};